import React from 'react';

// import { Container } from './styles';

export default function RecebeText({conteudo}) {
  return <>
    {conteudo}
  </>;
}
